import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, CirclePlay, CircleCheck, ChartBar } from "lucide-react";
export default function Davidlinthicumhero() {
  return <section data-section-id="254286" id="davidlinthicumhero" className="relative overflow-hidden bg-background text-foreground pt-24 pb-16 md:pt-32 md:pb-24 lg:pt-40 lg:pb-32">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-lg bg-secondary/10 blur-3xl" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col items-start space-y-8">
            <div className="inline-flex items-center gap-2 rounded-md border border-border bg-card/50 px-3 py-1 text-sm font-medium text-muted-foreground shadow-sm backdrop-blur-sm">
              <span className="flex h-2 w-2 rounded-md bg-secondary"></span>
              <span className="font-default">AI & Cloud Computing SME</span>
            </div>

            <div className="space-y-4">
              <h1 className="text-4xl font-bold tracking-tighter text-primary sm:text-5xl md:text-7xl font-default leading-[1.1]">
                David Scott Linthicum
              </h1>
              <p className="max-w-[600px] text-lg text-muted-foreground font-default leading-relaxed">
                Leading the evolution of AI and cloud computing. As a globally recognized influencer and consultant, I help organizations navigate complex digital transformations through strategic mentoring, content creation, and expert advisory.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto font-default text-base h-12 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-lg transition-all duration-300" asChild>
                <Link to="/ConnectPage">
                  Book David
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button size="lg" variant="secondary" className="w-full sm:w-auto font-default text-base h-12 px-8 border-primary/20 hover:bg-accent" asChild>
                <Link to="/MediaHubPage">
                  <CirclePlay className="mr-2 size-5" />
                  Watch Content
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-6 pt-4 text-sm text-muted-foreground font-default">
              <div className="flex items-center gap-2">
                <CircleCheck className="size-4 text-secondary" />
                <span>Strategic Mentoring</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="size-4 text-secondary" />
                <span>Global SME Influence</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-[600px] lg:max-w-none mt-8 lg:mt-0">
            {}
            <div className="relative rounded-lg border border-border/50 bg-card shadow-2xl overflow-hidden transform transition-transform duration-500 hover:scale-[1.02]">
              <div className="flex items-center gap-1.5 border-b border-border/50 bg-muted/30 px-4 py-3">
                <div className="size-3 rounded-md bg-destructive/80" />
                <div className="size-3 rounded-md bg-secondary/80" />
                <div className="size-3 rounded-md bg-primary/80" />
              </div>
              <div className="relative">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/David Linthicum Low Res.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/David Linthicum Low Res.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683668/img/David Linthicum Low Res.png-wvc-sizes" alt="David Scott Linthicum - AI and Cloud Expert" className="w-full h-auto object-cover block" loading="lazy" />
                <div className="absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-card to-transparent pointer-events-none" />
              </div>
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 rounded-md border border-border bg-card p-4 shadow-xl hidden md:flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
              <div className="flex size-10 items-center justify-center rounded-md bg-secondary/10 text-secondary">
                <ChartBar className="size-5" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground font-default">Cloud ROI</p>
                <p className="text-2xl font-bold text-primary font-default">Optimized</p>
              </div>
            </div>

            {}
            <div className="absolute -top-6 -right-6 rounded-md border border-border bg-card p-4 shadow-xl hidden lg:flex flex-col gap-2 animate-in fade-in slide-in-from-top-4 duration-1000 delay-500">
              <div className="flex items-center gap-2">
                <div className="size-2 rounded-md bg-secondary animate-pulse" />
                <p className="text-xs font-medium text-muted-foreground font-default">AI Readiness</p>
              </div>
              <p className="text-sm font-semibold text-foreground font-default">Enterprise Scale Active</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}